<template>
  <v-flex>
    <v-flex v-if='content_by_block_lesson' :class="{'px-4 pb-4': $vuetify.breakpoint.xs}">
      <component v-for="(block, i) in content_by_block_lesson.content" :key="block.content.video_id" :content='block.content'
                 class="mb-4" :is="block.type"
      />
      <buttonRed v-if="test_started && !test_finished" @click.native="test_resume()">{{ $t("Вернуться к тесту") }}</buttonRed>
      <buttonRed v-if="points_required_test > 0 && test_attempts > 0 && !test_started && course_started" @click.native="next_step()">{{ button_text }}</buttonRed>
      <buttonRed v-if="points_required_test == 0 && course_started && !course_completed" @click.native="next_step()">{{ $t("Завершить курс") }}</buttonRed>
    </v-flex>
    <v-flex v-else>
      <article style="padding: 8px 32px; font-size: 20px; font-weight: 600">
        <p>У данного курса отсутствует содержание</p>
      </article>
    </v-flex>
  </v-flex>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red.vue';
import courseDocuments from '@/components/blocks/content_blocks/block_documents.vue';
import courseSlider from '@/components/blocks/content_blocks/block_slider.vue';
import courseVideo from '@/components/blocks/content_blocks/block_video.vue';
import courseLinks from '@/components/blocks/content_blocks/block_links.vue';
import courseText from '@/components/blocks/content_blocks/block_text.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    slider     : courseSlider,
    courseVideo: courseVideo,
    documents  : courseDocuments,
    links      : courseLinks,
    courseText : courseText,
  },
  props: {
    isScorm: {
      type: Boolean
    },
  },
  computed: {
    ...mapGetters('course_info/content', [
      'content_by_block_lesson',
    ]),
    ...mapGetters('course_info', [
      'course_started',
      'course_completed',
      'test_started',
      'test_finished',
      'course_name',
      'points_earned_test',
      'points_required_test',
      'content_mobile_showed',
      'lessons_passed',
      'test_attempts',
      'completed_date',
    ]),
    ...mapGetters('course_info/steps', [
      'current_block',
      'lessons_total',
    ]),
    button_text() {
      if (this.lessons_passed < this.lessons_total-1) {
        return this.$t('Перейти к следующему разделу');
      }
      if (this.test_finished || this.completed_date) {
        return this.$t('Пройти тестирование заново');
      } else {
        return this.$t('Пройти итоговое тестирование');
      }
    },
  },
  methods: {
    ...mapMutations('course_info', [
      'HIDE_MOBILE',
    ]),
    ...mapActions('course_info/steps', [
      'next_step',
    ]),
    ...mapActions('testing', [
      'test_resume',
    ]),
  },
};
</script>
